// PostHog feature flag keys used across the app.
export const CHAT_WINDOW_FEATURE_FLAG = 'chat_window';
export const FREELANCE_FEATURE_FLAG = 'freelance';
